









import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import {
  CatalogEntityKind,
  getCatalogEntityFormConfig,
  parseCatalogEntityId
} from "./utils/openCatalogEntity";

@Component({
  computed: {
    ...mapGetters("ubic", ["isCatalog", "isAdmin"])
  }
})
export default class ProductCatalogEntityPage extends Vue {
  isCatalog!: boolean;
  isAdmin!: boolean;

  get canEditCatalog() {
    return !!(this.isCatalog || this.isAdmin);
  }

  get entityKind(): CatalogEntityKind {
    return this.$route.meta.catalogEntity as CatalogEntityKind;
  }

  get entityId() {
    return parseCatalogEntityId(this.$route.params.id, this.entityKind);
  }

  get formConfig() {
    if (this.entityId == null) {
      return null;
    }

    return getCatalogEntityFormConfig(
      this.entityKind,
      this.entityId,
      this.canEditCatalog
    );
  }

  get formComponent() {
    return this.formConfig && this.formConfig.component;
  }

  get formProps() {
    return this.formConfig && this.formConfig.props;
  }

  close() {
    this.$router.push({ name: "product-catalog" });
  }
}
